<div class="gallery-container">

  <span class="close" (click)="close()">✖</span>

  <img *ngIf="images.length > 1" alt="Left Arrow" class="arrow left-arrow" src="./assets/images/white_left_arrow.png" (click)="previous()">
  <div class="images-container" (click)="close()">
    <div *ngFor="let image of images; let i = index">
      <div *ngIf="i == position" class="image">
        <img alt="" class="image" [src]="image">
      </div>
    </div>
  </div>
  <img *ngIf="images.length > 1" alt="" class="arrow right-arrow" src="./assets/images/white_right_arrow.png" (click)="next()">

  <span *ngIf="images.length > 1" class="position-indicator">{{position+1}}/{{images.length}}</span>

</div>